import React from 'react';
interface LogoProps {
  variant?: 'light' | 'dark';
}
export function Logo({
  variant = 'light'
}: LogoProps) {
  const isDark = variant === 'dark';
  return <div className="flex flex-col leading-none" data-id="element-297" data-mp="8v62cptcae52">
      <span className={`font-display font-extrabold text-[20px] md:text-[22px] tracking-tight ${isDark ? 'text-arena' : 'text-verde'}`} data-id="element-298" data-mp="3qamd96hzfv5o">
        ORIGEN
      </span>
      <span className={`font-body font-semibold text-[9px] uppercase tracking-[0.2em] mt-1 ${isDark ? 'text-arena/60' : 'text-salvia'}`} data-id="element-299" data-mp="mscmanpsuivv">
        STUDIO
      </span>
    </div>;
}